import { createUseStyles } from "$utils/createUseStyles";

export const useStyles = createUseStyles(() => ({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  popinContainer: {
    display: "flex",
    flex: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  deleteButton: {
    height: 40,
    alignSelf: "center",
  },
  errorText: {
    textAlign: "center",
    color: "red",
  },
}));
